/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";

export function MagazineAmp({ color = "#c0c0c0" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85.65 65.58">
      <defs />
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            fill="none"
            stroke="#707070"
            strokeWidth={4.5}
            d="M84.4,7.62V63.19a.53.53,0,0,1-.8.45c-4.23-2.57-24.41-13.53-40.6.21l-.2.17-.15-.1c-2.92-1.85-23.74-14.15-40.54-.5A.53.53,0,0,1,1.25,63V7.35c0-.28,2.18-1.17,2.4-1.28q2.3-1.1,4.7-2A47.42,47.42,0,0,1,18.43,1.58,34.15,34.15,0,0,1,42.49,7,.5.5,0,0,0,43,7c.64-.37,1.85-.87,2-.95,1.53-.73,3.11-1.38,4.7-2A47.42,47.42,0,0,1,59.83,1.58,34.06,34.06,0,0,1,84.17,7.19.51.51,0,0,1,84.4,7.62Z"
          />
          <path className="cls-2" d="M7.85,19.38S22.33,9,37.58,19.38" fill="none" stroke="#e92227" strokeWidth={4.5} />
          <path className="cls-2" d="M7.85,33s14.48-10.37,29.73,0" fill="none" stroke="#e92227" strokeWidth={4.5} />
          <path className="cls-2" d="M7.85,46.8s14.48-10.37,29.73,0" fill="none" stroke="#e92227" strokeWidth={4.5} />
        </g>
      </g>
    </svg>
  );
}
MagazineAmp.propTypes = {
  color: PropTypes.string
};
